import React from 'react';
import { Link } from 'react-router-dom';

import { TermsContent } from '../components/TermsContent';

export function TermsPage() {
  return (
    <div className="page-grid single">
      <div style={{ marginBottom: '1rem' }}>
        <Link to="/calculator" className="link-button">
          ← Back to calculator
        </Link>
      </div>
      <TermsContent />
    </div>
  );
}
